/**
 * AppLayout Component
 *
 * Wraps the main application content and adjusts layout when the
 * global assistant panel is open, pushing content to the left.
 */
import React, { ReactNode } from 'react';
import { useGlobalAssistant } from '@/contexts/GlobalAssistantContext';

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const { isOpen, panelWidth } = useGlobalAssistant();

  return (
    <div
      className="min-h-screen transition-[margin] duration-200 ease-in-out"
      style={{ marginRight: isOpen ? panelWidth : 0 }}
    >
      {children}
    </div>
  );
}

export default AppLayout;
